export const MAXSIZE = 100000000; //bytes

export const FILETYPES = {
  "application/pdf": [".pdf"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/png": [".png"],
  "image/gif": [".gif"],
  // Add more types if needed
};

export const typeOptions = [
  {
    value: "once",
    label: "Once",
  },
  {
    value: "weekly",
    label: "Weekly",
  },
];

export const options = [
  { value: "daily check-in", label: "Daily Energy Check-in" },
  { value: "mood", label: "Mood" },
  { value: "journal", label: "Journal" },
  { value: "gratitude journal", label: "Gratitude Journal" },
  { value: "affirmations", label: "Affirmations" },
  { value: "body", label: "Body" },
  { value: "movement", label: "Movement" },
  { value: "breathe", label: "Breathe" },
  { value: "meditation", label: "Meditation" },
  { value: "visualization", label: "Visualization" },
  { value: "community", label: "Engage with community" },
];

export const ageOptions = [
  { value: "13", label: "13" },
  { value: "14", label: "14" },
  { value: "15", label: "15" },
  { value: "16", label: "16" },
  { value: "17", label: "17" },
  { value: "18", label: "18" },
  { value: "Adult", label: "Adult" },
];
